import {
  Component,
  OnInit,
  Input
} from '@angular/core';

@Component({
  selector: 'about',
  styles: [require('./about.component.scss')],
  template: require('./about.component.html')
})
export class AboutComponent {

  @Input() public title: string;
  @Input() public details: string;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/about/about.component.ts